import React, { useState } from "react";
import { useAuth } from "../components/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../apiBase";

const API = API_BASE;

export default function SubscribePage() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [busy, setBusy] = useState(false);

    const handleCheckout = async () => {
        setBusy(true);
        try {
            const origin = window.location.origin;
            const endpoint = user ? "/api/subscription/checkout" : "/api/subscription/checkout-guest";
            const { data } = await axios.post(`${API}${endpoint}`, { plan: "annual", origin_url: origin }, { withCredentials: true });
            window.location.href = data.url;
        } catch (err) {
            const detail = err.response?.data?.detail;
            const msg = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map(d => d.msg || JSON.stringify(d)).join("; ") : err.message || "Checkout failed";
            alert(msg);
            setBusy(false);
        }
    };

    const reason = user?.subscription?.reason || "no_subscription";
    const heading = !user ? "Full access to positioning data"
        : reason === "pending" ? "Full access to positioning data"
        : reason === "trial_expired" ? "Your free trial has ended"
        : reason === "subscription_expired" ? "Your subscription has expired"
        : user?.subscription?.active ? "You have an active subscription"
        : "Subscribe to continue";

    return (
        <div style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            background: "var(--pord-bg, #1a1e14)", fontFamily: "'DM Sans', sans-serif",
        }}>
            <div style={{ maxWidth: 480, padding: "40px 36px", textAlign: "center" }}>
                <h1 style={{ fontSize: 36, fontWeight: 300, color: "#DAF2D0", marginBottom: 8, letterSpacing: 2 }}>Pord.</h1>
                <p data-testid="subscribe-heading" style={{ fontSize: 16, color: "rgba(255,255,255,0.6)", marginBottom: 32 }}>{heading}</p>

                <div style={{
                    padding: "36px 32px", borderRadius: 14,
                    background: "rgba(184,212,208,0.04)", border: "1px solid rgba(184,212,208,0.15)",
                    marginBottom: 32,
                }}>
                    <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 12, letterSpacing: 1, textTransform: "uppercase" }}>Annual Access</div>
                    <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: 4, marginBottom: 8 }}>
                        <span style={{ fontSize: 48, fontWeight: 300, color: "#DAF2D0" }}>$250</span>
                        <span style={{ fontSize: 14, color: "rgba(255,255,255,0.4)" }}>/year</span>
                    </div>
                    <p style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 24, lineHeight: 1.6 }}>
                        Weekly positioning dashboard, charting tools, and data API access
                    </p>
                    <button
                        data-testid="plan-annual"
                        onClick={handleCheckout}
                        disabled={busy || (user?.subscription?.active && reason !== "subscription_expired")}
                        style={{
                            width: "100%", padding: "14px 0", borderRadius: 8,
                            cursor: busy ? "wait" : "pointer",
                            background: busy ? "rgba(218,242,208,0.15)" : "#DAF2D0",
                            border: "none",
                            color: "#1a1e14", fontSize: 15, fontWeight: 600,
                            fontFamily: "'DM Sans', sans-serif",
                            opacity: (user?.subscription?.active && reason !== "subscription_expired") ? 0.4 : 1,
                            transition: "all 200ms",
                        }}
                    >
                        {busy ? "Redirecting to Stripe..." : user?.subscription?.active ? "Already subscribed" : "Subscribe now"}
                    </button>
                </div>

                {user ? (
                    <>
                        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 24 }}>
                            Subscribing as <strong style={{ color: "#DAF2D0" }}>{user?.email}</strong>
                            <span style={{ margin: "0 6px" }}>&middot;</span>
                            <button onClick={() => { logout(); window.location.href = "/"; }} style={{
                                background: "none", border: "none", color: "rgba(255,255,255,0.4)",
                                fontSize: 12, cursor: "pointer", textDecoration: "underline", fontFamily: "'DM Sans', sans-serif", padding: 0,
                            }}>use a different email</button>
                        </div>
                        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginBottom: 16 }}>Secure payment via Stripe. Cancel anytime.</p>
                        <button onClick={logout} style={{
                            background: "none", border: "none", color: "rgba(255,255,255,0.3)",
                            fontSize: 12, cursor: "pointer", textDecoration: "underline", fontFamily: "'DM Sans', sans-serif",
                        }}>Sign out</button>
                    </>
                ) : (
                    <>
                        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 16 }}>
                            <a href="/login" style={{ color: "#DAF2D0", textDecoration: "underline", textUnderlineOffset: 2 }}>Sign in</a> or <a href="/login" style={{ color: "#DAF2D0", textDecoration: "underline", textUnderlineOffset: 2 }}>create an account</a> to subscribe
                        </p>
                        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)" }}>Secure payment via Stripe. Cancel anytime.</p>
                    </>
                )}
            </div>
        </div>
    );
}
